export enum LocationGroupAPIUrls {
    CreateLocationGroup ='/api/LocationsGroup/CreateLocationsGroupByMLS',
    GetLocationGroupsByPlanContainerID ='/api/LocationsGroup/GetLocationsGroupsByPlanContainerID',
    DeleteLocationGroup ='/api/LocationsGroup/DeleteLocationsGroup',
    EditLocationGroup ='/api/LocationsGroup/EditLocationsGroupByMLS',
    GetLocationsGroupsById = '/api/LocationsGroup/GetLocationsGroupsById',    
    CreateLocationGroupsForAMS = '/api/LocationsGroup/CreateLocationsGroupsByAMS',
    UpdateLocationGroupTitle= '/api/LocationsGroup/UpdateLocationGroupTitle'  
  }